import React from 'react';
import T from 'prop-types';
import cx from 'classnames';

import Container from '../../../../components/Container';

const MainSideLayout = ({ mainContent, sideContent, title, className }) => (
  <div className={cx('main-side-layout', className)}>
    <Container maxWidth={1248}>
      {title}
      <div className="main-side-layout__content">
        <div className="main-side-layout__content-main">{mainContent}</div>
        <div className="main-side-layout__content-side">{sideContent}</div>
      </div>
    </Container>
  </div>
);

MainSideLayout.propTypes = {
  mainContent: T.node.isRequired,
  sideContent: T.node.isRequired,
  title: T.node,
  className: T.string,
};

export default MainSideLayout;
